import React from 'react';
import { getFormmateedPriceString } from 'qs-helpers/Orders/OrderPriceCalculator';
import './styles.scss';

export default ({ name, pictureUrl, price, quantity, isLoading, onIncrement, onDecrement }) => {
  const total = (price || 0) * (quantity || 0);

  return (
    <div className="scannedProductRow">
      <div className="scannedProductImage">
        {pictureUrl ? <img src={pictureUrl} alt="" /> : <div className="scannedProductNoImage" />}
      </div>
      <div className="scannedProductInfo">
        <div className="scannedProductName ellipsis">{name}</div>
        <div className="scannedProductBreakup">
          {getFormmateedPriceString({ price })} x {quantity}
        </div>
        <div className="scannedProductTotal">{getFormmateedPriceString({ price: total })}</div>
      </div>
      <div className="scannedProductActions">
        <button
          type="button"
          className={`decrementButton${
            isLoading || quantity <= 1 ? ' quantityButtonDisabled' : ''
          }`}
          disabled={isLoading || quantity <= 1}
          onClick={onDecrement}
        >
          -
        </button>
        <span>{quantity}</span>
        <button
          type="button"
          className={`incrementButton${isLoading ? ' quantityButtonDisabled' : ''}`}
          disabled={isLoading}
          onClick={onIncrement}
        >
          +
        </button>
      </div>
    </div>
  );
};
